import { render, staticRenderFns } from "./editIndex.vue?vue&type=template&id=24e1e46c&scoped=true"
import script from "./editIndex.vue?vue&type=script&lang=js"
export * from "./editIndex.vue?vue&type=script&lang=js"
import style0 from "./editIndex.vue?vue&type=style&index=0&id=24e1e46c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e1e46c",
  null
  
)

export default component.exports